import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CarrierInvoiceFile } from 'src/app/_models/models';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class CarrierInvoiceFilesService {

  constructor(private common: CommonService, private client: HttpClient) { }

  getAll(name: string): Observable<CarrierInvoiceFile[]> {

    let url = this.common.getApiAddress();

    if (name == undefined || name == null) {
      url = url + "/CarrierInvoiceFiles"
    } else {
      url = url + "/CarrierInvoiceFiles?name=" + name;
    }

    return this.client.get<CarrierInvoiceFile[]>(url)
      .pipe(
      map<CarrierInvoiceFile[], CarrierInvoiceFile[]>(
          r => {
            return r;
          }
        ),
        catchError(
          e => {
            return this.common.handleError("Carrier invoice file get failed", e);
          }
        )
      );
  }

  get(id:number, action:string): Observable<any>{
    return this.client.get<CarrierInvoiceFile[]>(this.common.getApiAddress() + "/CarrierInvoiceFiles/" + id.toString() + "?action=" + action)
    .pipe(
      map<any, any>(
        r => {
          return r;
        }
      ),
      catchError(
        e => {
          return this.common.handleError("Carrier invoice file get failed", e);
        }
      )
    );
  }

  create(data: any): Observable<CarrierInvoiceFile> {
    return this.client.post<CarrierInvoiceFile>(this.common.getApiAddress() + "/CarrierInvoiceFiles", data)
      .pipe(
        map<CarrierInvoiceFile, CarrierInvoiceFile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create carrier failed", e);
        })
      );
  }

  delete(id:number): Observable<CarrierInvoiceFile>{
    return this.client.delete<CarrierInvoiceFile>(this.common.getApiAddress() + "/CarrierInvoiceFiles/" + id.toString())
      .pipe(
        map<CarrierInvoiceFile, CarrierInvoiceFile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Deleting Carrier Invoice file failed", e);
        })
      );
  }

}
